export const getFullName = (firstName: string | undefined, lastName: string | undefined): string => {
    if (!firstName && !lastName) return ''; // Both are empty
    if (!firstName) return lastName || '';  // Only last name provided
    if (!lastName) return firstName;        // Only first name provided
    return `${firstName} ${lastName}`;      // Both provided
}